import '../styling/Contact.css';

const Contact = () => {
  return (
    <div id="contact-section" className="contact">
      <div className="contact-content">
        <h3 className="contact-subtitle">Contact</h3>
        <h2 className="contact-title">I'd Love To Hear From You.</h2>

        <div className="contact-info">
          <div className="contact-box">
            <div className="contact-icon">📍</div>
            <h4 className="contact-label">Where to find me</h4>
            <p>Iraq, Baghdad</p>
           
          </div>

          <div className="contact-box">
            <div className="contact-icon">📩</div>
            <h4 className="contact-label">Email me at</h4>
            <p>ahmadattwi753@gmail.com</p>
          </div>

          <div className="contact-box">
            <div className="contact-icon">📞</div>
            <h4 className="contact-label">Call me at</h4>
            <p>+964 777 503 9259</p>
          </div>
        </div>

        <div className="contact-socials">
          <a
    href="https://www.linkedin.com/in/ahmad-attwi-286408243/"
    target="_blank"
    rel="noopener noreferrer"
    title="Visit my LinkedIn"
  >
    <i className="fab fa-linkedin" style={{ fontSize: "18px" ,color:"white"}}></i>
  </a>


     
     
  <a
    href="https://github.com/ahma20d"
    target="_blank"
    rel="noopener noreferrer"
    title="Visit my GitHub"
  >
    <i className="fab fa-github" style={{ fontSize: "18px",color:"white" }}></i>
  </a>




  <a
    href="https://wa.me/9647775039259"
    target="_blank"
    rel="noopener noreferrer"
    title="Chat with me on WhatsApp"
  >
    <i className="fab fa-whatsapp" style={{ fontSize: "18px" ,color:"white"}}></i>
  </a>



  <a
    href="mailto:ahmadattwi753@gmail.com"
    title="Send me an email"
  >
    <i className="fas fa-envelope" style={{ fontSize: "18px" ,color:"white"}}></i>
  </a>

          
        </div>
      </div>
    </div>
  );
};

export default Contact;
